var timeout;
function countdown(time_in_seconds) {
  if (time_in_seconds <= 0) {
    document.querySelectorAll(".countdown").forEach(el => el.style.display = 'none');
    return false;
  }

  var seconds = time_in_seconds % 60;
  var minutes = (time_in_seconds / 60) % 60;
  var hours = (time_in_seconds / 3600) % 24;
  var days = time_in_seconds / (3600 * 24);

  const secEl = document.querySelector(".countdown .seconds");
  const minEl = document.querySelector(".countdown .minutes");
  const hourEl = document.querySelector(".countdown .hours");
  const dayEl = document.querySelector(".countdown .days");

  if (secEl) secEl.innerHTML = ("0" + Math.trunc(seconds)).slice(-2);
  if (minEl) minEl.innerHTML = ("0" + Math.trunc(minutes)).slice(-2);
  if (hourEl) hourEl.innerHTML = ("0" + Math.trunc(hours)).slice(-2);
  if (dayEl) dayEl.innerHTML = ("0" + Math.trunc(days)).slice(-2);

  timeout = setTimeout(() => {
    countdown(time_in_seconds - 1);
  }, 1000);
}

document.addEventListener("turbo:before-cache", () => {
  if (timeout) {
    clearTimeout(timeout);
  }
});

document.addEventListener("turbo:load", () => {
  const body = document.body;
  if (body && (
      body.classList.contains("site-landingpage") ||
      body.classList.contains("home-index") ||
      body.classList.contains("payment-new") ||
      body.classList.contains("posts-show") ||
      body.classList.contains("lessons-show")
    )) {
    const countdownEl = document.querySelector(".countdown");
    if (countdownEl) {
      var time_in_seconds = parseInt(countdownEl.getAttribute("data-seconds")) || 0;
      console.log("time_in_seconds", time_in_seconds);
      console.log("hello");
      countdown(time_in_seconds);
    }
  }
});
